import { alpha } from "@mui/material";

// export default function Loader(theme) {
//     return {
//         MuiBackdrop: {
//             styleOverrides: {
//                 root: ({ theme }) => ({
//                     zIndex: 2000,
//                     backgroundColor: alpha(theme.palette.grey[200], 0.1),
//                     backdropFilter: 'blur(2px)',
//                     display: 'flex',
//                     flexDirection: 'column',
//                     gap: theme.spacing(2),
//                     position: 'fixed',
//                     color: theme.palette.primary.main,
//                 }),
//             },
//         },
//         MuiCircularProgress: {
//             styleOverrides: {
//                 root: {
//                     color: theme.palette.primary.main,
//                 },
//             },
//         },
//     };
// }

export default function Loader(theme) {
    return {
        MuiBackdrop: {
            styleOverrides: {
                root: {
                    // Use a value higher than standard MUI AppBars/Drawers
                    zIndex: 3000, 
                    backgroundColor: alpha(theme.palette.grey[200], 0.1),
                    backdropFilter: 'blur(0.5px)',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100vw',
                    height: '100vh',
                },
            },
        },
    };
}